module.exports = __webpack_public_path__ + "img/ball_2.9a09d333.png";